// extracted by mini-css-extract-plugin
module.exports = {"table":"TokensList_table__uZ68D","toggle":"TokensList_toggle__3_d4J"};